import { useState, useId, useEffect } from "react";
import { useCombobox } from "downshift";
import { useSpinDelay } from "spin-delay";

import { getProductList } from "../../../services/inventory";

export const useProductComboBox = ({ onChange, defaultProduct = null }) => {
  const id = useId();
  const [products, setProducts] = useState(
    defaultProduct ? [defaultProduct] : [],
  );
  const [selectedProduct, setSelectedProduct] = useState(
    defaultProduct || null,
  );
  const [isLoading, setIsLoading] = useState(false);

  const cb = useCombobox({
    id,
    initialSelectedItem: defaultProduct || null,
    initialInputValue: defaultProduct?.name || "",
    onSelectedItemChange: ({ selectedItem }) => {
      onChange(selectedItem);
      setSelectedProduct(selectedItem);
    },
    items: products,
    itemToString: (item) => (item ? item?.name : ""),
    onInputValueChange: (changes) => {
      if (changes.inputValue) {
        handleFetchProducts(changes.inputValue);
      }
    },
  });

  useEffect(() => {
    if (defaultProduct && defaultProduct?.name) {
      setSelectedProduct(defaultProduct);
      setProducts([defaultProduct]);
      if (cb?.selectItem) {
        cb.selectItem(defaultProduct);
      }
      if (cb?.setInputValue) {
        cb.setInputValue(defaultProduct.name);
      }
    }
  }, [defaultProduct?.id, defaultProduct?.name]); // eslint-disable-line react-hooks/exhaustive-deps

  const displayMenu = cb.isOpen && products.length > 0;
  const showSpinner = useSpinDelay(isLoading, {
    delay: 150,
    minDuration: 500,
  });

  const handleFetchProducts = (query) => {
    setIsLoading(true);
    getProductList(`?query=${query}`)
      .then((response) => {
        setProducts(response.data?.data);
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  return { cb, products, selectedProduct, isLoading, displayMenu, showSpinner };
};
